var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoctorCategory = function SvgDoctorCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doctor-category_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doctor-category_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M19.14 17.347a2.887 2.887 0 1 0 0-5.774 2.887 2.887 0 0 0 0 5.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBC7",
    d: "M22.264 11.228c.175-.829-.226-1.616-.895-1.758-.67-.142-1.356.415-1.532 1.243s.226 1.615.896 1.757 1.355-.414 1.53-1.243M11.261 12.481c.67-.142 1.07-.929.895-1.757-.175-.829-.86-1.385-1.53-1.243s-1.072.929-.896 1.757c.176.829.861 1.385 1.531 1.243"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6DEC5",
    d: "M27.134 28.247H4.86V25.58a7.193 7.193 0 0 1 7.2-7.193h1.714L16 24.007l2.227-5.567h1.713a7.193 7.193 0 0 1 7.194 7.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBC7",
    d: "M18.227 15.3h-4.454v3.367h4.454zM18.227 18.667h-4.454L16 23.987z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66AF8C",
    d: "M23.14 24.087h-1.167V22.92h-1.667v1.167H19.14v1.666h1.166v1.167h1.667v-1.167h1.167z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M20.46 11.34a6.3 6.3 0 0 0 .46-3.293 4.974 4.974 0 0 0-4.92-4.3 4.97 4.97 0 0 0-4.92 4.293 7.3 7.3 0 0 0 .3 3.293"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDBC7",
    d: "M15.92 4.853a4.54 4.54 0 0 0-4.54 4.54v2.187a6.5 6.5 0 0 0 .613 2.787 4.15 4.15 0 0 0 3.927 2.666 4.15 4.15 0 0 0 3.927-2.666 6.5 6.5 0 0 0 .613-2.787V9.393a4.54 4.54 0 0 0-4.54-4.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M11.066 9.907a7.8 7.8 0 0 1-.04-1.84A5.05 5.05 0 0 1 16 3.747a4.97 4.97 0 0 1 4.92 4.293c.057.527.057 1.06 0 1.587l-.474.44a36.5 36.5 0 0 1-6.78-3.88s-.513 2.726-2.3 3.713z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doctor-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "doctor-category_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgDoctorCategory;